export const LANGUAGE_KEY = "lang"

export function getStoredLanguage(): string {
  if (typeof window === "undefined") return "es"
  return (
    localStorage.getItem("lang") ||
    document.cookie.match(/NEXT_LOCALE=([^;]+)/)?.[1] ||
    "es"
  )
}

export function setStoredLanguage(lang: string): void {
  if (typeof window === "undefined") return
  localStorage.setItem("lang", lang)
  document.cookie = `NEXT_LOCALE=${lang};path=/;max-age=${60 * 60 * 24 * 365}`
}
